export default __webpack_public_path__ + "static/media/list-view-icon.600435d9.svg";